import { render, staticRenderFns } from "./HomepageConfig.vue?vue&type=template&id=022ea49f&scoped=true&"
import script from "./HomepageConfig.vue?vue&type=script&lang=js&"
export * from "./HomepageConfig.vue?vue&type=script&lang=js&"
import style0 from "./HomepageConfig.vue?vue&type=style&index=0&id=022ea49f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ea49f",
  null
  
)

export default component.exports